import { Locale } from 'chaika-enums';
export const scheduleModule = {
    emptyScheduleV2: {
        [Locale.Ru]: `Нет расписаний, удовлетворяющих заданным условиям`,
        [Locale.Am]: `Չկան նշված պայմաններին համապատասխանող ժամանակացույցեր`,
        [Locale.En]: `There are no schedules that meet the specified conditions`,
        [Locale.Pt]: `Não existem horários que reúnam as condições especificadas`,
        [Locale.Ge]: `There are no schedules that meet the specified conditions`,
    },
    scheduleNeedsDoctorOrPatient: {
        [Locale.Ru]: `Выберите доктора или пациента`,
        [Locale.Am]: `Ընտրեք բժիշկ կամ պացիենտ`,
        [Locale.En]: `Select a doctor or a patient`,
        [Locale.Pt]: `Selecione um médico ou um paciente`,
        [Locale.Ge]: `Select a doctor or a patient`,
    },
    scheduleNeedsDoctorOrPatientOrOrganizationOrSpecialty: {
        [Locale.Ru]: `Выберите клинику, доктора, специальность или пациента`,
        [Locale.Am]: `Ընտրեք կլինիկա, բժիշկ, մասնագիտություն կամ պացիենտ`,
        [Locale.En]: `Select a clinic, a doctor, a specialty or a patient`,
        [Locale.Pt]: `Selecione uma clínica, um médico, uma especialidade ou um paciente`,
        [Locale.Ge]: `Select a clinic, a doctor, a specialty or a patient`,
    },
    scheduleLegend: {
        [Locale.Ru]: `Обозначения в расписании`,
        [Locale.Am]: `Նշանները ժամանակացույցում`,
        [Locale.En]: `Designations in the schedule`,
        [Locale.Pt]: 'Designações na programação',
        [Locale.Ge]: `Designations in the schedule`,
    },
    serviceNeedIdsText: {
        [Locale.Ru]: `Для услуги необходимо подписать идс и оно ещё не подписано`,
        [Locale.Am]: `Ծառայության համար անհրաժեշտ է ստորագրել տեղեկացված համաձայնությունը, և այն դեռ ստորագրված չէ`,
        [Locale.En]: `The service requires signing the IDS and it has not been signed yet`,
        [Locale.Pt]: 'O serviço requer assinatura do IDS e ainda não foi assinado',
        [Locale.Ge]: `The service requires signing the IDS and it has not been signed yet`,
    },
    currentPatientProgram: {
        [Locale.Ru]: `Действующая программа пациента`,
        [Locale.Am]: `Պացիենտի գործող ծրագիրը`,
        [Locale.En]: `Current patient program`,
        [Locale.Pt]: 'Programa atual do paciente',
        [Locale.Ge]: `Current patient program`,
    },
    filtered: {
        [Locale.Ru]: `Отфильтровано`,
        [Locale.Am]: `Զտված է`,
        [Locale.En]: `Filtered`,
        [Locale.Pt]: 'Filtrado',
        [Locale.Ge]: `Filtered`,
    },
    nonWorking: {
        [Locale.Ru]: `Неработающие`,
        [Locale.Am]: `Չաշխատողներ`,
        [Locale.En]: `Non-working`,
        [Locale.Pt]: 'Não trabalhando',
        [Locale.Ge]: `Non-working`,
    },
    cancelledReservations: {
        [Locale.Ru]: `Отмененные брони`,
        [Locale.Am]: `Չեղարկված ամրագրումներ`,
        [Locale.En]: `Cancelled Reservations`,
        [Locale.Pt]: 'Reservas canceladas',
        [Locale.Ge]: `Cancelled Reservations`,
    },
    movedReservations: {
        [Locale.Ru]: `Перенесенные брони`,
        [Locale.Am]: `Տեղափոխված ամրագրումներ`,
        [Locale.En]: `Moved Reservations`,
        [Locale.Pt]: 'Reservas remarcadas',
        [Locale.Ge]: `Moved Reservations`,
    },
    hasReplyEntryText: {
        [Locale.Ru]: `На данную бронь в расписании есть ответная запись в карте`,
        [Locale.Am]: `Ժամանակացույցում այս ամրագրման համար քարտում կա պատասխան գրառում`,
        [Locale.En]: `There is a reply entry in the map for this booking in the schedule`,
        [Locale.Pt]: 'Há uma entrada de resposta no mapa para esta reserva na programação',
        [Locale.Ge]: `There is a reply entry in the map for this booking in the schedule`,
    },
    fullIncNeedReferralText: {
        [Locale.Ru]: `У пациента есть полная страховка. Услуга не консультативная и требует направления для оплаты по страховке`,
        [Locale.Am]: `Պացիենտն ունի ամբողջական ապահովագրություն։ Ծառայությունը խորհրդատվական չէ և պահանջում է ուղեգիր ապահովագրությամբ վճարելու համար`,
        [Locale.En]: `The patient has full insurance. The service is not consultative and requires a referral for payment by insurance.`,
        [Locale.Pt]: 'O paciente tem seguro total. O serviço não é consultivo e exige encaminhamento para pagamento pelo seguro.',
        [Locale.Ge]: `The patient has full insurance. The service is not consultative and requires a referral for payment by insurance.`,
    },
    onlineConsultation: {
        [Locale.Ru]: `Онлайн-консультация`,
        [Locale.Am]: `Առցանց խորհրդատվություն`,
        [Locale.En]: `Online consultation`,
        [Locale.Pt]: 'Consulta on-line',
        [Locale.Ge]: `Online consultation`,
    },
    onlineVisit: {
        [Locale.Ru]: `Онлайн визит`,
        [Locale.Am]: `Առցանց այց`,
        [Locale.En]: `Online visit`,
        [Locale.Pt]: 'Visita on-line',
        [Locale.Ge]: `Online visit`,
    },
    firstTimePatient: {
        [Locale.Ru]: `Пациент пришел первый раз`,
        [Locale.Am]: `Պացիենտն առաջին անգամ է եկել`,
        [Locale.En]: `The patient came for the first time`,
        [Locale.Pt]: 'O paciente veio pela primeira vez',
        [Locale.Ge]: `The patient came for the first time`,
    },
    askNoToBeNotified: {
        [Locale.Ru]: `Пациент просил его «не уведомлять»`,
        [Locale.Am]: `Պացիենտը խնդրել է իրեն «չծանուցել»`,
        [Locale.En]: `The patient asked him not to be notified.`,
        [Locale.Pt]: 'O paciente pediu que ele não fosse avisado.',
        [Locale.Ge]: `The patient asked him not to be notified.`,
    },
    reception: {
        [Locale.Ru]: `Приём`,
        [Locale.Am]: `Ընդունելություն`,
        [Locale.En]: `Reception`,
        [Locale.Pt]: 'Recepção',
        [Locale.Ge]: `Reception`,
    },
    severalSM: {
        [Locale.Ru]: `Несколько моделей расписания`,
        [Locale.Am]: `Ժամանակացույցի մի քանի մոդել`,
        [Locale.En]: `Several schedule models`,
        [Locale.Pt]: 'Vários modelos de cronograma',
        [Locale.Ge]: `Several schedule models`,
    },
    patientCame: {
        [Locale.Ru]: `Пациент пришёл`,
        [Locale.Am]: `Պացիենտը եկել է`,
        [Locale.En]: `The patient came`,
        [Locale.Pt]: 'O paciente veio',
        [Locale.Ge]: `The patient came`,
    },
    replyEntrySignedText: {
        [Locale.Ru]: `Ответную запись в карте подписали`,
        [Locale.Am]: `Քարտում պատասխան գրառումը ստորագրվել է`,
        [Locale.En]: `The reply entry in the card was signed`,
        [Locale.Pt]: 'A entrada de resposta no cartão foi assinada',
        [Locale.Ge]: `The reply entry in the card was signed`,
    },
    patientHasDept: {
        [Locale.Ru]: `У пациента долг`,
        [Locale.Am]: `Պացիենտն ունի պարտք`,
        [Locale.En]: `The patient has a debt`,
        [Locale.Pt]: 'O paciente tem uma dívida',
        [Locale.Ge]: `The patient has a debt`,
    },
    entrySignWithECP: {
        [Locale.Ru]: `Запись подписана ЭЦП`,
        [Locale.Am]: `Գրառումը ստորագրված է էլեկտրոնային ստորագրությամբ`,
        [Locale.En]: `The entry is signed with an electronic digital signature`,
        [Locale.Pt]: 'A entrada é assinada com uma assinatura digital eletrônica',
        [Locale.Ge]: `The entry is signed with an electronic digital signature`,
    },
    signedWithEDS: {
        [Locale.Ru]: `Подписана ЭЦП`,
        [Locale.Am]: `Ստորագրված է էլեկտրոնային ստորագրությամբ`,
        [Locale.En]: `Signed with an EDS`,
        [Locale.Pt]: 'Assinado com um EDS',
        [Locale.Ge]: `Signed with an EDS`,
    },
    sorting: {
        [Locale.Ru]: `Сортировка`,
        [Locale.Am]: `Դասավորում`,
        [Locale.En]: `Sorting`,
        [Locale.Pt]: 'Classificando',
        [Locale.Ge]: `Sorting`,
    },
    sortBy: {
        [Locale.Ru]: `Сортировать по`,
        [Locale.Am]: `Դասավորել ըստ`,
        [Locale.En]: `Sort by`,
        [Locale.Pt]: 'Ordenar por',
        [Locale.Ge]: `Sort by`,
    },
    fromCard: {
        [Locale.Ru]: `Из карты`,
        [Locale.Am]: `Քարտից`,
        [Locale.En]: `From the card`,
        [Locale.Pt]: 'Do cartão',
        [Locale.Ge]: `From the card`,
    },
    servicesAndPayment: {
        [Locale.Ru]: `Услуги и оплата`,
        [Locale.Am]: `Ծառայություններ և վճարում`,
        [Locale.En]: `Services and payment`,
        [Locale.Pt]: 'Serviços e pagamento',
        [Locale.Ge]: `Services and payment`,
    },
    hasLinkedCard: {
        [Locale.Ru]: `Есть привязанная банковская карта`,
        [Locale.Am]: `Կա կցված բանկային քարտ`,
        [Locale.En]: `There is a linked bank card`,
        [Locale.Pt]: 'Existe um cartão bancário vinculado',
        [Locale.Ge]: `There is a linked bank card`,
    },
    reservationDetailLoadFailed: {
        [Locale.Ru]: `Не загрузилось`,
        [Locale.Am]: `Չի բեռնվել`,
        [Locale.En]: `Failed to load`,
        [Locale.Pt]: 'Falha ao carregar',
        [Locale.Ge]: `Failed to load`,
    },
    reservationDetailBankCard: {
        [Locale.Ru]: `банковская карта`,
        [Locale.Am]: `բանկային քարտ`,
        [Locale.En]: `bank card`,
        [Locale.Pt]: 'cartão bancário',
        [Locale.Ge]: `bank card`,
    },
    reservationDetailDebt: {
        [Locale.Ru]: `задолженность`,
        [Locale.Am]: `պարտք`,
        [Locale.En]: `debt`,
        [Locale.Pt]: 'dívida',
        [Locale.Ge]: `debt`,
    },
    reservationDetailPlans: {
        [Locale.Ru]: `программы`,
        [Locale.Am]: `ծրագրեր`,
        [Locale.En]: `plans`,
        [Locale.Pt]: 'programas',
        [Locale.Ge]: `plans`,
    },
    reservationDetailSimilarEhrs: {
        [Locale.Ru]: `похожие карты`,
        [Locale.Am]: `նման քարտեր`,
        [Locale.En]: `similar records`,
        [Locale.Pt]: 'registos semelhantes',
        [Locale.Ge]: `similar records`,
    },
    reservationDetailIntersectionPatients: {
        [Locale.Ru]: `пересечения`,
        [Locale.Am]: `հատումներ`,
        [Locale.En]: `overlaps`,
        [Locale.Pt]: 'sobreposições',
        [Locale.Ge]: `overlaps`,
    },
    reservationDetailAttentions: {
        [Locale.Ru]: `предупреждения`,
        [Locale.Am]: `նախազգուշացումներ`,
        [Locale.En]: `warnings`,
        [Locale.Pt]: 'avisos',
        [Locale.Ge]: `warnings`,
    },
    reservationDetailCancellationPenalty: {
        [Locale.Ru]: `штраф за отмену`,
        [Locale.Am]: `չեղարկման տուգանք`,
        [Locale.En]: `cancellation penalty`,
        [Locale.Pt]: 'multa por cancelamento',
        [Locale.Ge]: `cancellation penalty`,
    },
    reservationDetailEntryStatus: {
        [Locale.Ru]: `статус приёма`,
        [Locale.Am]: `ընդունելության կարգավիճակ`,
        [Locale.En]: `entry status`,
        [Locale.Pt]: 'estado da consulta',
        [Locale.Ge]: `entry status`,
    },
    reservationDetailEntryCreationAccess: {
        [Locale.Ru]: `права на создание приёма`,
        [Locale.Am]: `ընդունելություն ստեղծելու իրավունքներ`,
        [Locale.En]: `entry creation rights`,
        [Locale.Pt]: 'permissões para criar consulta',
        [Locale.Ge]: `entry creation rights`,
    },
    linkToOnlineConsultation: {
        [Locale.Ru]: `Ссылки на онлайн-консультацию`,
        [Locale.Am]: `Առցանց խորհրդատվության հղումներ`,
        [Locale.En]: `Links to online consultation`,
        [Locale.Pt]: 'Links para consulta on-line',
        [Locale.Ge]: `Links to online consultation`,
    },
    forDoctor: {
        [Locale.Ru]: `Для врача`,
        [Locale.Am]: `Բժշկի համար`,
        [Locale.En]: `For the doctor`,
        [Locale.Pt]: 'Para o médico',
        [Locale.Ge]: `For the doctor`,
    },
    forPatient: {
        [Locale.Ru]: `Для пациента`,
        [Locale.Am]: `Պացիենտի համար`,
        [Locale.En]: `For the patient`,
        [Locale.Pt]: 'Para o paciente',
        [Locale.Ge]: `For the patient`,
    },
    payLateCancellingText: {
        [Locale.Ru]: `Оплата бронирования при поздней отмене`,
        [Locale.Am]: `Ամրագրման վճար ուշ չեղարկման դեպքում`,
        [Locale.En]: `Payment for booking in case of late cancellation`,
        [Locale.Pt]: 'Pagamento da reserva em caso de cancelamento tardio',
        [Locale.Ge]: `Payment for booking in case of late cancellation`,
    },
    checkEhrDublText: {
        [Locale.Ru]: `Проверьте возможные дубли медкарты`,
        [Locale.Am]: `Ստուգեք բժշկական քարտի հնարավոր կրկնօրինակները`,
        [Locale.En]: `Check for possible duplicates of medical records`,
        [Locale.Pt]: 'Verifique possíveis duplicatas de registros médicos',
        [Locale.Ge]: `Check for possible duplicates of medical records`,
    },
    createEntry: {
        [Locale.Ru]: `Создать запись`,
        [Locale.Am]: `Ստեղծել գրառում`,
        [Locale.En]: `Create a entry`,
        [Locale.Pt]: 'Crie uma entrada',
        [Locale.Ge]: `Create a entry`,
    },
    entryPublished: {
        [Locale.Ru]: `Запись опубликована`,
        [Locale.Am]: `Գրառումը հրապարակված է`,
        [Locale.En]: `The entry has been published`,
        [Locale.Pt]: 'A entrada foi publicada',
        [Locale.Ge]: `The entry has been published`,
    },
    surcharge: {
        [Locale.Ru]: `Доплата`,
        [Locale.Am]: `Հավելավճար`,
        [Locale.En]: `Surcharge`,
        [Locale.Pt]: 'Sobretaxa',
        [Locale.Ge]: `Surcharge`,
    },
    priceWithSurchange: {
        [Locale.Ru]: `Цена с учетом доплаты`,
        [Locale.Am]: `Գինը՝ հավելավճարով`,
        [Locale.En]: `Price including surcharge`,
        [Locale.Pt]: 'Preço incluindo sobretaxa',
        [Locale.Ge]: `Price including surcharge`,
    },
    priceWithInsText: {
        [Locale.Ru]: `Цены при применении страховых программ`,
        [Locale.Am]: `Գները ապահովագրական ծրագրերի կիրառման դեպքում`,
        [Locale.En]: `Prices when using insurance programs`,
        [Locale.Pt]: 'Preços ao usar programas de seguro',
        [Locale.Ge]: `Prices when using insurance programs`,
    },
    hideFullName: {
        [Locale.Ru]: `Скрыть ФИО`,
        [Locale.Am]: `Թաքցնել անուն, ազգանուն, հայրանուն`,
        [Locale.En]: `Hide full name`,
        [Locale.Pt]: 'Ocultar nome completo',
        [Locale.Ge]: `Hide full name`,
    },
    showFullName: {
        [Locale.Ru]: `Показать ФИО`,
        [Locale.Am]: `Ցուցադրել անուն, ազգանուն, հայրանուն`,
        [Locale.En]: `Show full name`,
        [Locale.Pt]: 'Mostrar nome completo',
        [Locale.Ge]: `Show full name`,
    },
    showNonWorking: {
        [Locale.Ru]: `Показать неработающих`,
        [Locale.Am]: `Ցուցադրել չաշխատողներին`,
        [Locale.En]: `Show non-working`,
        [Locale.Pt]: 'Mostrar que não funciona',
        [Locale.Ge]: `Show non-working`,
    },
    hideNonWorking: {
        [Locale.Ru]: `Скрыть неработающих`,
        [Locale.Am]: `Թաքցնել չաշխատողներին`,
        [Locale.En]: `Hide non-working`,
        [Locale.Pt]: 'Ocultar que não funciona',
        [Locale.Ge]: `Hide non-working`,
    },
    showCancelledReservations: {
        [Locale.Ru]: `Показать отмененные брони`,
        [Locale.Am]: `Ցուցադրել չեղարկված ամրագրումները`,
        [Locale.En]: `Show cancelled reservations`,
        [Locale.Pt]: 'Mostrar reservas canceladas',
        [Locale.Ge]: `Show cancelled reservations`,
    },
    hideCancelledReservations: {
        [Locale.Ru]: `Скрыть отмененные брони`,
        [Locale.Am]: `Թաքցնել չեղարկված ամրագրումները`,
        [Locale.En]: `Hide cancelled reservations`,
        [Locale.Pt]: 'Ocultar reservas canceladas',
        [Locale.Ge]: `Hide cancelled reservations`,
    },
    byOffice: {
        [Locale.Ru]: `Кабинету`,
        [Locale.Am]: `Ըստ կաբինետի`,
        [Locale.En]: `Office`,
        [Locale.Pt]: 'Escritório',
        [Locale.Ge]: `Office`,
    },
    bySurnames: {
        [Locale.Ru]: `Фамилии`,
        [Locale.Am]: `Ըստ ազգանվան`,
        [Locale.En]: `Surnames`,
        [Locale.Pt]: 'Sobrenomes',
        [Locale.Ge]: `Surnames`,
    },
    byDay: {
        [Locale.Ru]: `Дням`,
        [Locale.Am]: `Ըստ օրերի`,
        [Locale.En]: `Day`,
        [Locale.Pt]: 'Dia',
        [Locale.Ge]: `Day`,
    },
    hasDublText: {
        [Locale.Ru]: `Возможно, есть дубль медкарты`,
        [Locale.Am]: `Հնարավոր է՝ կա բժշկական քարտի կրկնօրինակ`,
        [Locale.En]: `There may be a duplicate medical record.`,
        [Locale.Pt]: 'Pode haver um prontuário médico duplicado.',
        [Locale.Ge]: `There may be a duplicate medical record.`,
    },
    hasDebt: {
        [Locale.Ru]: `Есть долг`,
        [Locale.Am]: `Կա պարտք`,
        [Locale.En]: `There is a debt`,
        [Locale.Pt]: 'Há uma dívida',
        [Locale.Ge]: `There is a debt`,
    },
    noGender: {
        [Locale.Ru]: `Не указан пол`,
        [Locale.Am]: `Սեռը նշված չէ`,
        [Locale.En]: `Gender not specified`,
        [Locale.Pt]: 'Sexo não especificado',
        [Locale.Ge]: `Gender not specified`,
    },
    primaryDocNotSigned: {
        [Locale.Ru]: `Не подписаны первичные документы`,
        [Locale.Am]: `Առաջնային փաստաթղթերը ստորագրված չեն`,
        [Locale.En]: `Primary documents not signed`,
        [Locale.Pt]: 'Documentos primários não assinados',
        [Locale.Ge]: `Primary documents not signed`,
    },
    contractNotSigned: {
        [Locale.Ru]: `Не подписан договор`,
        [Locale.Am]: `Պայմանագիրը ստորագրված չէ`,
        [Locale.En]: `The contract has not been signed`,
        [Locale.Pt]: 'O contrato não foi assinado',
        [Locale.Ge]: `The contract has not been signed`,
    },
    icdNotSigned: {
        [Locale.Ru]: `Не подписано ИДС`,
        [Locale.Am]: `Տեղեկացված համաձայնությունը ստորագրված չէ`,
        [Locale.En]: `The ICD is not signed`,
        [Locale.Pt]: 'O CDI não foi assinado',
        [Locale.Ge]: `The ICD is not signed`,
    },
    noSignedIcdWithLegalEntityText: {
        [Locale.Ru]: `У пациента нет подписанного ИДС с юрлицом приёма`,
        [Locale.Am]: `Պացիենտը չունի ստորագրված տեղեկացված համաձայնություն ընդունելության իրավաբանական անձի հետ`,
        [Locale.En]: `The patient has no signed ICD with the visit's legal entity`,
        [Locale.Pt]: 'O paciente não possui CDI assinado com a entidade legal da consulta',
        [Locale.Ge]: `The patient has no signed ICD with the visit's legal entity`,
    },
    needICDForService: {
        [Locale.Ru]: `Необходимо ИДС для услуги`,
        [Locale.Am]: `Ծառայության համար անհրաժեշտ է տեղեկացված համաձայնություն`,
        [Locale.En]: `Need ICD for service`,
        [Locale.Pt]: 'Precisa de CDI para serviço',
        [Locale.Ge]: `Need ICD for service`,
    },
    pleaseDontCall: {
        [Locale.Ru]: `Просьба не звонить пациенту`,
        [Locale.Am]: `Խնդրում ենք չզանգահարել պացիենտին`,
        [Locale.En]: `Please do not call the patient`,
        [Locale.Pt]: 'Todos',
        [Locale.Ge]: `Please do not call the patient`,
    },
    needConfirmPassport: {
        [Locale.Ru]: `Необходимо подтвердить паспортные данные`,
        [Locale.Am]: `Անհրաժեշտ է հաստատել անձնագրային տվյալները`,
        [Locale.En]: `It is necessary to confirm passport details`,
        [Locale.Pt]: 'É necessário confirmar os dados do passaporte',
        [Locale.Ge]: `It is necessary to confirm passport details`,
    },
    needConfirmAdditionalData: {
        [Locale.Ru]: `Необходимо подтвердить дополнительные данные`,
        [Locale.Am]: `Անհրաժեշտ է հաստատել լրացուցիչ տվյալները`,
        [Locale.En]: `Additional details need to be confirmed`,
        [Locale.Pt]: 'Detalhes adicionais precisam ser confirmados',
        [Locale.Ge]: `Additional details need to be confirmed`,
    },
    createReserv: {
        [Locale.Ru]: `Создать резерв`,
        [Locale.Am]: `Ստեղծել պահուստ`,
        [Locale.En]: `Create a reserve`,
        [Locale.Pt]: 'Crie uma reserva',
        [Locale.Ge]: `Create a reserve`,
    },
    notEnoughTime: {
        [Locale.Ru]: `Недостаточно времени для бронирования услуги.`,
        [Locale.Am]: `Ծառայությունն ամրագրելու համար ժամանակը բավարար չէ։`,
        [Locale.En]: `Not enough time to book the service.`,
        [Locale.Pt]: 'Não há tempo suficiente para reservar o serviço.',
        [Locale.Ge]: `Not enough time to book the service.`,
    },
    bookOutOfTimeText: {
        [Locale.Ru]: `Вы записываете пациента на нерабочее время. Все равно записать?`,
        [Locale.Am]: `Դուք գրանցում եք պացիենտին ոչ աշխատանքային ժամի։ Այնուամենայնի՞վ գրանցել`,
        [Locale.En]: `You are booking a patient for a non-working hour. Should you still book them?`,
        [Locale.Pt]: 'Você está agendando um paciente para um horário não comercial. Você ainda deve reservá-los?',
        [Locale.Ge]: `You are booking a patient for a non-working hour. Should you still book them?`,
    },
    $outOfTimeText: {
        [Locale.Ru]: `Выбрано нерабочее время. Все равно $action?`,
        [Locale.Am]: `Ընտրված է ոչ աշխատանքային ժամ։ Այնուամենայնի՞վ $action`,
        [Locale.En]: `A non-working hour is selected. Still want to $action?`,
        [Locale.Pt]: 'Foi selecionado um horário não comercial. Ainda assim $action?',
        [Locale.Ge]: `არჩეულია არასამუშაო დრო. მაინც $action?`,
    },
    reservationConflictWarning: {
        [Locale.Ru]: `На это время уже есть бронь у того же доктора. Все равно записать?`,
        [Locale.Am]: `Այս ժամին նույն բժիշկն արդեն ունի ամրագրում։ Այնուամենայնի՞վ գրանցել`,
        [Locale.En]: `The doctor already has a reservation at this time. Book anyway?`,
        [Locale.Pt]: `O médico já tem uma reserva neste horário. Reservar mesmo assim?`,
        [Locale.Ge]: `The doctor already has a reservation at this time. Book anyway?`,
    },
    reservationConflictBlock: {
        [Locale.Ru]: `На это время уже есть бронь у того же доктора. Запись на занятое время невозможна.`,
        [Locale.Am]: `Այս ժամին նույն բժիշկն արդեն ունի ամրագրում։ Զբաղված ժամին գրանցումն անհնար է։`,
        [Locale.En]: `The doctor already has a reservation at this time. A new booking cannot be placed on a busy slot.`,
        [Locale.Pt]: `O médico já tem uma reserva neste horário. Não é possível agendar em um horário ocupado.`,
        [Locale.Ge]: `The doctor already has a reservation at this time. A new booking cannot be placed on a busy slot.`,
    },
    reservationIntersectionBlock: {
        [Locale.Ru]: `На это время уже есть другая бронь. Запись на занятое время невозможна.`,
        [Locale.Am]: `Այս ժամին արդեն կա այլ ամրագրում։ Զբաղված ժամին գրանցումն անհնար է։`,
        [Locale.En]: `This time is already taken by another reservation. A new booking cannot be placed on a busy slot.`,
        [Locale.Pt]: `Este horário já está ocupado por outra reserva. Não é possível agendar em um horário ocupado.`,
        [Locale.Ge]: `This time is already taken by another reservation. A new booking cannot be placed on a busy slot.`,
    },
    startOfReception: {
        [Locale.Ru]: `Начало приема`,
        [Locale.Am]: `Ընդունելության սկիզբ`,
        [Locale.En]: `Start of reception`,
        [Locale.Pt]: 'Início da recepção',
        [Locale.Ge]: `Start of reception`,
    },
    receptionDuration: {
        [Locale.Ru]: `Длительность приема`,
        [Locale.Am]: `Ընդունելության տևողություն`,
        [Locale.En]: `Duration of reception`,
        [Locale.Pt]: 'Duração da recepção',
        [Locale.Ge]: `Duration of reception`,
    },
    communicationMethod: {
        [Locale.Ru]: `Способ связи`,
        [Locale.Am]: `Կապի եղանակ`,
        [Locale.En]: `Method of communication`,
        [Locale.Pt]: 'Método de comunicação',
        [Locale.Ge]: `Method of communication`,
    },
    mainMethod: {
        [Locale.Ru]: `Основной способ`,
        [Locale.Am]: `Հիմնական եղանակ`,
        [Locale.En]: `Main method`,
        [Locale.Ge]: `Main method`,
        [Locale.Pt]: `Método principal`,
    },
    selectCommunicationMethod: {
        [Locale.Ru]: `Выберете способ связи`,
        [Locale.Am]: `Ընտրեք կապի եղանակը`,
        [Locale.En]: `Select a method of communication`,
        [Locale.Pt]: 'Selecione um método de comunicação',
        [Locale.Ge]: `Select a method of communication`,
    },
    doctorLink: {
        [Locale.Ru]: `Ссылка врача`,
        [Locale.Am]: `Բժշկի հղում`,
        [Locale.En]: `Doctor's link`,
        [Locale.Pt]: 'Link do médico',
        [Locale.Ge]: `Doctor's link`,
    },
    patientLink: {
        [Locale.Ru]: `Ссылка пациента`,
        [Locale.Am]: `Պացիենտի հղում`,
        [Locale.En]: `Patient link`,
        [Locale.Pt]: 'Link do paciente',
        [Locale.Ge]: `Patient link`,
    },
    patientHasReferrals: {
        [Locale.Ru]: `У пациента есть направления`,
        [Locale.Am]: `Պացիենտն ունի ուղեգրեր`,
        [Locale.En]: `The patient has referrals`,
        [Locale.Pt]: `O paciente tem encaminhamentos`,
        [Locale.Ge]: `The patient has referrals`,
    },
    selectReferralsForReservations: {
        [Locale.Ru]: `Выберите направления, для которых вы хотите создать записи`,
        [Locale.Am]: `Ընտրեք ուղեգրերը, որոնց համար ցանկանում եք ստեղծել գրանցումներ`,
        [Locale.En]: `Select the referrals you want to create appointments for`,
        [Locale.Pt]: `Selecione os encaminhamentos para os quais deseja criar agendamentos`,
        [Locale.Ge]: `Select the referrals you want to create appointments for`,
    },
    selectedReferrals: {
        [Locale.Ru]: `Выбранные направления`,
        [Locale.Am]: `Ընտրված ուղեգրեր`,
        [Locale.En]: `Selected referrals`,
        [Locale.Pt]: `Encaminhamentos selecionados`,
        [Locale.Ge]: `Selected referrals`,
    },
    notEnoughFreeTimeForOtherReferrals: {
        [Locale.Ru]: `Для ответа на другие направления с этим временем начала события недостаточно свободного времени`,
        [Locale.Am]: `Այս մեկնարկի ժամով մյուս ուղեգրերին պատասխանելու համար ազատ ժամանակը բավարար չէ`,
        [Locale.En]: `There is not enough free time to answer the other referrals with this start time`,
        [Locale.Pt]: `Não há tempo livre suficiente para responder aos outros encaminhamentos com este horário de início`,
        [Locale.Ge]: `There is not enough free time to answer the other referrals with this start time`,
    },
    notEnoughFreeTimeForReferrals: {
        [Locale.Ru]: `Для ответа на направления с этим временем начала события недостаточно свободного времени`,
        [Locale.Am]: `Այս մեկնարկի ժամով ուղեգրերին պատասխանելու համար ազատ ժամանակը բավարար չէ`,
        [Locale.En]: `There is not enough free time to answer the referrals with this start time`,
        [Locale.Pt]: `Não há tempo livre suficiente para responder aos encaminhamentos com este horário de início`,
        [Locale.Ge]: `There is not enough free time to answer the referrals with this start time`,
    },
    unbindReferral: {
        [Locale.Ru]: `Отвязать направление`,
        [Locale.Am]: `Անջատել ուղեգիրը`,
        [Locale.En]: `Unbind referral`,
        [Locale.Pt]: 'Desvincular referência',
        [Locale.Ge]: `Unbind referral`,
    },
    allShouldBeInSameClinic: {
        [Locale.Ru]: `Все участники должны быть в одной клинике`,
        [Locale.Am]: `Բոլոր մասնակիցները պետք է լինեն նույն կլինիկայում`,
        [Locale.En]: `All participants must be in the same clinic.`,
        [Locale.Pt]: 'Todos os participantes devem estar na mesma clínica.',
        [Locale.Ge]: `All participants must be in the same clinic.`,
    },
    cancelNeedCardText: {
        [Locale.Ru]: `Отменить проверку обязательная банковская карта`,
        [Locale.Am]: `Չեղարկել պարտադիր բանկային քարտի ստուգումը`,
        [Locale.En]: `Cancel verification mandatory bank card`,
        [Locale.Pt]: 'Cancelar verificação obrigatória do cartão bancário',
        [Locale.Ge]: `Cancel verification mandatory bank card`,
    },
    doNotNotify: {
        [Locale.Ru]: `Не уведомлять`,
        [Locale.Am]: `Չծանուցել`,
        [Locale.En]: `Do not notify`,
        [Locale.Pt]: 'Não avise',
        [Locale.Ge]: `Do not notify`,
    },
    checkServicesCostForPatient: {
        [Locale.Ru]: `Проверить стоимость услуг для пациента →`,
        [Locale.Am]: `Ստուգել ծառայությունների արժեքը պացիենտի համար →`,
        [Locale.En]: `Check services cost for the patient →`,
        [Locale.Pt]: 'Verificar o custo dos serviços para o paciente →',
        [Locale.Ge]: `Check services cost for the patient →`,
    },
    selectOrCreateNewPatient: {
        [Locale.Ru]: `Выберите или создайте нового`,
        [Locale.Am]: `Ընտրեք կամ ստեղծեք նորը`,
        [Locale.En]: `Select or create a new one`,
        [Locale.Pt]: 'Selecione ou crie um novo',
        [Locale.Ge]: `Select or create a new one`,
    },
    insuranceProgram: {
        [Locale.Ru]: `Программа страхования`,
        [Locale.Am]: `Ապահովագրական ծրագիր`,
        [Locale.En]: `Insurance program`,
        [Locale.Pt]: 'Programa de seguro',
        [Locale.Ge]: `Insurance program`,
    },
    noActiveInsurancePrograms: {
        [Locale.Ru]: `Нет активных программ страхования`,
        [Locale.Am]: `Ակտիվ ապահովագրական ծրագրեր չկան`,
        [Locale.En]: `No active insurance programs`,
        [Locale.Pt]: 'Sem programas de seguro ativos',
        [Locale.Ge]: `No active insurance programs`,
    },
    planPays: {
        [Locale.Ru]: `$planName оплачивает`,
        [Locale.Am]: `$planName վճարում է`,
        [Locale.En]: `$planName pays`,
        [Locale.Pt]: '$planName paga',
        [Locale.Ge]: `$planName pays`,
    },
    cancelButton: {
        [Locale.Ru]: `Отмена`,
        [Locale.Am]: `Չեղարկում`,
        [Locale.En]: `Cancel`,
        [Locale.Pt]: 'Cancelar',
        [Locale.Ge]: `Cancel`,
    },
    coveredByInsurance: {
        [Locale.Ru]: `По страховке`,
        [Locale.Am]: `Ապահովագրությամբ`,
        [Locale.En]: `By insurance`,
        [Locale.Pt]: 'Pelo seguro',
        [Locale.Ge]: `By insurance`,
    },
    notCoveredByInsurance: {
        [Locale.Ru]: `Не покрывается страховкой`,
        [Locale.Am]: `Չի ծածկվում ապահովագրությամբ`,
        [Locale.En]: `Not covered by insurance`,
        [Locale.Pt]: 'Não coberto pelo seguro',
        [Locale.Ge]: `Not covered by insurance`,
    },
    servicesNotSelected: {
        [Locale.Ru]: `Услуги не выбраны`,
        [Locale.Am]: `Ծառայություններ ընտրված չեն`,
        [Locale.En]: `No services selected`,
        [Locale.Pt]: 'Nenhum serviço selecionado',
        [Locale.Ge]: `No services selected`,
    },
    servicesCost: {
        [Locale.Ru]: `Стоимость услуг`,
        [Locale.Am]: `Ծառայությունների արժեքը`,
        [Locale.En]: `Services cost`,
        [Locale.Pt]: 'Custo dos serviços',
        [Locale.Ge]: `Services cost`,
    },
    newEvent: {
        [Locale.Ru]: `Новое событие`,
        [Locale.Am]: `Նոր իրադարձություն`,
        [Locale.En]: `New event`,
        [Locale.Pt]: 'Novo evento',
        [Locale.Ge]: `New event`,
    },
    eventSettings: {
        [Locale.Ru]: `Настройки события`,
        [Locale.Am]: `Իրադարձության կարգավորումներ`,
        [Locale.En]: `Event settings`,
        [Locale.Pt]: 'Configurações do evento',
        [Locale.Ge]: `Event settings`,
    },
    ignorePayCancellation: {
        [Locale.Ru]: `Игнорировать оплату поздней отмены`,
        [Locale.Am]: `Անտեսել ուշ չեղարկման վճարը`,
        [Locale.En]: `Ignore late cancellation fees`,
        [Locale.Pt]: 'Ignore as taxas de cancelamento tardio',
        [Locale.Ge]: `Ignore late cancellation fees`,
    },
    ignoreAgeLimit: {
        [Locale.Ru]: `Игнорировать ограничение по возрасту`,
        [Locale.Am]: `Անտեսել տարիքային սահմանափակումը`,
        [Locale.En]: `Ignore age restriction`,
        [Locale.Pt]: 'Ignorar restrição de idade',
        [Locale.Ge]: `Ignore age restriction`,
    },
    incorrectAge: {
        [Locale.Ru]: `Возраст не соответствует заданному для врача`,
        [Locale.Am]: `Տարիքը չի համապատասխանում բժշկի համար սահմանվածին`,
        [Locale.En]: `Age does not match that specified for the doctor`,
        [Locale.Pt]: 'Idade não corresponde ao especificado para o médico',
        [Locale.Ge]: `Age does not match that specified for the doctor`,
    },
    serviceNoFound: {
        [Locale.Ru]: `Услуга не найдена`,
        [Locale.Am]: `Ծառայությունը չի գտնվել`,
        [Locale.En]: `Service not found`,
        [Locale.Pt]: 'Serviço não encontrado',
        [Locale.Ge]: `Service not found`,
    },
    statusChanged: {
        [Locale.Ru]: `Изменен статус`,
        [Locale.Am]: `Կարգավիճակը փոփոխվել է`,
        [Locale.En]: `Status changed`,
        [Locale.Pt]: 'Status alterado',
        [Locale.Ge]: `Status changed`,
    },
    entryCreated: {
        [Locale.Ru]: `Создана запись`,
        [Locale.Am]: `Ստեղծվել է գրառում`,
        [Locale.En]: `Entry created`,
        [Locale.Pt]: 'Entrada criada',
        [Locale.Ge]: `Entry created`,
    },
    doctorOrDevice: {
        [Locale.Ru]: `Доктор или прибор`,
        [Locale.Am]: `Բժիշկ կամ սարք`,
        [Locale.En]: `Doctor or device`,
        [Locale.Pt]: 'Médico ou dispositivo',
        [Locale.Ge]: `Doctor or device`,
    },
    addPatient: {
        [Locale.Ru]: `Добавить пациента`,
        [Locale.Am]: `Ավելացնել պացիենտ`,
        [Locale.En]: `Add patient`,
        [Locale.Pt]: 'Adicionar paciente',
        [Locale.Ge]: `Add patient`,
    },
    patientComment: {
        [Locale.Ru]: `Комментарий пациента`,
        [Locale.Am]: `Պացիենտի մեկնաբանություն`,
        [Locale.En]: `Patient comment`,
        [Locale.Pt]: 'Paciente como',
        [Locale.Ge]: `Patient comment`,
    },
    calendarAndFilters: {
        [Locale.Ru]: `Календарь и фильтры`,
        [Locale.Am]: `Օրացույց և զտիչներ`,
        [Locale.En]: `Календарь и фильтры`,
        [Locale.Pt]: 'Calendário e filtros',
        [Locale.Ge]: `Календарь и фильтры`,
    },
    errorOnMovingBooking: {
        [Locale.Ru]: `Возникла ошибка при перемещении брони.`,
        [Locale.Am]: `Ամրագրումը տեղափոխելիս առաջացել է սխալ։`,
        [Locale.En]: `An error occurred while moving the armor.`,
        [Locale.Pt]: 'Ocorreu um erro ao mover a armadura.',
        [Locale.Ge]: `An error occurred while moving the armor.`,
    },
    errorOnSaveBooking: {
        [Locale.Ru]: `Возникла ошибка при сохранении брони.`,
        [Locale.Am]: `Ամրագրումը պահպանելիս առաջացել է սխալ։`,
        [Locale.En]: `Возникла ошибка при сохранении брони.`,
        [Locale.Pt]: 'Ocorreu um erro ao salvar a reserva.',
        [Locale.Ge]: `Возникла ошибка при сохранении брони.`,
    },
    errorOnCreateBooking: {
        [Locale.Ru]: `Возникла ошибка при создании брони.`,
        [Locale.Am]: `Ամրագրում ստեղծելիս առաջացել է սխալ։`,
        [Locale.En]: `There was an error creating the reservation.`,
        [Locale.Pt]: 'Ocorreu um erro ao criar a reserva.',
        [Locale.Ge]: `There was an error creating the reservation.`,
    },
    bookingNotCreated: {
        [Locale.Ru]: `Бронь не создалась`,
        [Locale.Am]: `Ամրագրումը չի ստեղծվել`,
        [Locale.En]: `The reservation was not created`,
        [Locale.Pt]: 'A reserva não foi criada',
        [Locale.Ge]: `The reservation was not created`,
    },
    errorOnCancelBooking: {
        [Locale.Ru]: `Возникла ошибка при отмене брони.`,
        [Locale.Am]: `Ամրագրումը չեղարկելիս առաջացել է սխալ։`,
        [Locale.En]: `An error occurred while cancelling the reservation.`,
        [Locale.Pt]: 'Ocorreu um erro ao cancelar a reserva.',
        [Locale.Ge]: `An error occurred while cancelling the reservation.`,
    },
    otherSpecDevText: {
        [Locale.Ru]: `Другие специальности/типы приборов`,
        [Locale.Am]: `Այլ մասնագիտություններ/սարքերի տեսակներ`,
        [Locale.En]: `Other specialties/types of devices`,
        [Locale.Pt]: 'Outras especialidades/tipos de dispositivos',
        [Locale.Ge]: `Other specialties/types of devices`,
    },
    relatedEntry: {
        [Locale.Ru]: `Связанная запись`,
        [Locale.Am]: `Կապված գրառում`,
        [Locale.En]: `Related entry`,
        [Locale.Pt]: 'Entrada relacionada',
        [Locale.Ge]: `Related entry`,
    },
    entryStatus: {
        [Locale.Ru]: `Статус записи`,
        [Locale.Am]: `Գրառման կարգավիճակ`,
        [Locale.En]: `Entry status`,
        [Locale.Pt]: 'Status de entrada',
        [Locale.Ge]: `Entry status`,
    },
    communicationChannel: {
        [Locale.Ru]: `Канал связи`,
        [Locale.Am]: `Կապի ալիք`,
        [Locale.En]: `Communication channel`,
        [Locale.Pt]: 'Canal de comunicação',
        [Locale.Ge]: `Communication channel`,
    },
    meetLink: {
        [Locale.Ru]: `Ссылка на встречу`,
        [Locale.Am]: `Հանդիպման հղում`,
        [Locale.En]: `Meeting link`,
        [Locale.Pt]: `Link da reunião`,
        [Locale.Ge]: `შეხვედრის ბმული`,
    },
    lunch: {
        [Locale.Ru]: `Обед`,
        [Locale.Am]: `Ճաշ`,
        [Locale.En]: `Lunch`,
        [Locale.Pt]: 'Almoço',
        [Locale.Ge]: `Lunch`,
    },
    vacation: {
        [Locale.Ru]: `Отпуск`,
        [Locale.Am]: `Արձակուրդ`,
        [Locale.En]: `Vacation`,
        [Locale.Pt]: 'Férias',
        [Locale.Ge]: `Vacation`,
    },
    diseaseSchedule: {
        [Locale.Ru]: `Болезнь`,
        [Locale.Am]: `Հիվանդություն`,
        [Locale.En]: `Disease`,
        [Locale.Pt]: 'Doença',
        [Locale.Ge]: `Disease`,
    },
    meeting: {
        [Locale.Ru]: `Встреча`,
        [Locale.Am]: `Հանդիպում`,
        [Locale.En]: `Meeting`,
        [Locale.Pt]: 'Reunião',
        [Locale.Ge]: `Meeting`,
    },
    training: {
        [Locale.Ru]: `Обучение`,
        [Locale.Am]: `Ուսուցում`,
        [Locale.En]: `Training`,
        [Locale.Pt]: 'Treinamento',
        [Locale.Ge]: `Training`,
    },
    vaccinationSingle: {
        [Locale.Ru]: `Вакцинация`,
        [Locale.Am]: `Պատվաստում`,
        [Locale.En]: `Vaccination`,
        [Locale.Pt]: 'Vacinação',
        [Locale.Ge]: `Vaccination`,
    },
    fiveMinutes: {
        [Locale.Ru]: `Пятиминутка`,
        [Locale.Am]: `Հնգրոպեանոց`,
        [Locale.En]: `Five minutes`,
        [Locale.Pt]: 'Cinco minutos',
        [Locale.Ge]: `Five minutes`,
    },
    notWorkTime: {
        [Locale.Ru]: `Нерабочее время`,
        [Locale.Am]: `Ոչ աշխատանքային ժամ`,
        [Locale.En]: `Not Work Time`,
        [Locale.Pt]: 'Não é horário de trabalho',
        [Locale.Ge]: `Not Work Time`,
    },
    waitingList: {
        [Locale.Ru]: `Лист ожидания`,
        [Locale.Am]: `Սպասման ցուցակ`,
        [Locale.En]: `Waiting List`,
        [Locale.Pt]: 'Lista de espera',
        [Locale.Ge]: `Waiting List`,
    },
    operation: {
        [Locale.Ru]: `Операция`,
        [Locale.Am]: `Վիրահատություն`,
        [Locale.En]: `Operation`,
        [Locale.Pt]: 'Operação',
        [Locale.Ge]: `Operation`,
    },
    appointment: {
        [Locale.Ru]: `Запись`,
        [Locale.Am]: `Գրանցում`,
        [Locale.En]: `Appointment`,
        [Locale.Pt]: 'Agendamento',
        [Locale.Ge]: `Appointment`,
    },
    onlineAppointment: {
        [Locale.Ru]: `Онлайн-запись`,
        [Locale.Am]: `Առցանց գրանցում`,
        [Locale.En]: `Online appointment`,
        [Locale.Pt]: 'Agendamento online',
        [Locale.Ge]: `Online appointment`,
    },
    timeBlock: {
        [Locale.Ru]: `Занятое время`,
        [Locale.Am]: `Զբաղված ժամ`,
        [Locale.En]: `Time block`,
        [Locale.Pt]: 'Bloqueio de horário',
        [Locale.Ge]: `Time block`,
    },
    roomBooking: {
        [Locale.Ru]: `Бронь кабинета`,
        [Locale.Am]: `Կաբինետի ամրագրում`,
        [Locale.En]: `Room booking`,
        [Locale.Pt]: 'Reserva de sala',
        [Locale.Ge]: `Room booking`,
    },
    timeBlockCardTitle: {
        [Locale.Ru]: `Занятое время`,
        [Locale.Am]: `Զբաղված ժամ`,
        [Locale.En]: `Time block`,
        [Locale.Pt]: 'Bloqueio de horário',
        [Locale.Ge]: `Time block`,
    },
    roomBookingCardTitle: {
        [Locale.Ru]: `Бронь`,
        [Locale.Am]: `Ամրագրում`,
        [Locale.En]: `Booking`,
        [Locale.Pt]: 'Reserva',
        [Locale.Ge]: `Booking`,
    },
    userWith: {
        [Locale.Ru]: `Пользователь с`,
        [Locale.Am]: `Օգտատերը՝`,
        [Locale.En]: `User with`,
        [Locale.Pt]: 'Usuário com',
        [Locale.Ge]: `User with`,
    },
    userNotFound: {
        [Locale.Ru]: 'Пользователь не найден',
        [Locale.Am]: 'Օգտատերը չի գտնվել',
        [Locale.En]: `User not found`,
        [Locale.Pt]: 'Usuário não encontrado',
        [Locale.Ge]: `User not found`,
    },
    wrongPassword: {
        [Locale.Ru]: 'Неверный пароль',
        [Locale.Am]: 'Սխալ գաղտնաբառ',
        [Locale.En]: `Wrong password`,
        [Locale.Pt]: 'Senha errada',
        [Locale.Ge]: `Wrong password`,
    },
    deviceWith: {
        [Locale.Ru]: `Прибор с`,
        [Locale.Am]: `Սարքը՝`,
        [Locale.En]: `Device with`,
        [Locale.Pt]: 'Dispositivo com',
        [Locale.Ge]: `Device with`,
    },
    officeWith: {
        [Locale.Ru]: `Офис с`,
        [Locale.Am]: `Կաբինետը՝`,
        [Locale.En]: `Office with`,
        [Locale.Pt]: 'Escritório com',
        [Locale.Ge]: `Office with`,
    },
    clearFilters: {
        [Locale.Ru]: `Очистить фильтры`,
        [Locale.Am]: `Մաքրել զտիչները`,
        [Locale.En]: `Clear filters`,
        [Locale.Pt]: 'Limpar filtros',
        [Locale.Ge]: `Clear filters`,
    },
    deviceReservationFrom: {
        [Locale.Ru]: `С $date — $time`,
        [Locale.Am]: `Սկսած $date — $time`,
        [Locale.En]: `From $date — $time`,
        [Locale.Pt]: 'De $date — $time',
        [Locale.Ge]: `From $date — $time`,
    },
    deviceReservationTo: {
        [Locale.Ru]: `До $date — $time`,
        [Locale.Am]: `Մինչև $date — $time`,
        [Locale.En]: `Until $date — $time`,
        [Locale.Pt]: 'Até $date — $time',
        [Locale.Ge]: `Until $date — $time`,
    },
    startsInPreviousWeek: {
        [Locale.Ru]: `Начало на предыдущей неделе`,
        [Locale.Am]: `Սկիզբը նախորդ շաբաթում`,
        [Locale.En]: `Starts in the previous week`,
        [Locale.Pt]: 'Começa na semana anterior',
        [Locale.Ge]: `Starts in the previous week`,
    },
    endsInNextWeek: {
        [Locale.Ru]: `Окончание на следующей неделе`,
        [Locale.Am]: `Ավարտը հաջորդ շաբաթում`,
        [Locale.En]: `Ends in the next week`,
        [Locale.Pt]: 'Termina na próxima semana',
        [Locale.Ge]: `Ends in the next week`,
    },
    showWeekRange: {
        [Locale.Ru]: `Показать неделю $range`,
        [Locale.Am]: `Ցուցադրել $range շաբաթը`,
        [Locale.En]: `Show week $range`,
        [Locale.Pt]: 'Mostrar semana $range',
        [Locale.Ge]: `Show week $range`,
    },
    information: {
        [Locale.Ru]: `Информация`,
        [Locale.Am]: `Տեղեկություններ`,
        [Locale.En]: `Information`,
        [Locale.Pt]: 'Informações',
        [Locale.Ge]: `ინფორმაცია`,
    },
    patientsReception: {
        [Locale.Ru]: `Прием пациентов`,
        [Locale.Am]: `Պացիենտների ընդունելություն`,
        [Locale.En]: `Patient appointments`,
        [Locale.Pt]: 'Atendimento de pacientes',
        [Locale.Ge]: `პაციენტების მიღება`,
    },
    languageKnowledge: {
        [Locale.Ru]: `Знание языков`,
        [Locale.Am]: `Լեզուների իմացություն`,
        [Locale.En]: `Languages`,
        [Locale.Pt]: 'Idiomas',
        [Locale.Ge]: `ენების ცოდნა`,
    },
    telegramChat: {
        [Locale.Ru]: `Чат в Telegram`,
        [Locale.Am]: `Չատ Telegram-ում`,
        [Locale.En]: `Telegram chat`,
        [Locale.Pt]: 'Chat no Telegram',
        [Locale.Ge]: `ჩატი Telegram-ში`,
    },
    // NAME: {
    //     [Locale.Ru]: ``,
    //     [Locale.Am]: ``,
    //     [Locale.En]: ``,
    // [Locale.Pt]: '',
    //     [Locale.Ge]: ``,
    // },
};
